/**
 * Validate that string have the correct phone format
 * Format valid: (33) 3761-8690, 3335976089, +52 3335976089
 */
export function validatePhone(phone) {
  // eslint-disable-next-line
  const phoneRegEx = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$$/;
  return phoneRegEx.test(phone) && phone.length >= 8;
}

/**
 * Validate that string have the correct email format
 * Format valid: cadena@cadena.co,
 */
export function validateEmail(email) {
  // eslint-disable-next-line
  const mailRegexp = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
  return mailRegexp.test(String(email));
}
